import GeneralProductInformationStepV2 from './GeneralProductInformationStepHost.vue'
import { generalProductInformationV2Descriptor } from './descriptor'
import { createGeneralProductInformationV2Controller } from './general-product-information-v2-controller'
import { createGeneralProductInformationReviewContribution } from './review-contribution'

const generalProductInformationV2StepImplementation = Object.freeze({
    descriptor: generalProductInformationV2Descriptor,
    component: GeneralProductInformationStepV2,
    createController: createGeneralProductInformationV2Controller,
    createReviewContribution: createGeneralProductInformationReviewContribution,
})

export {
    GeneralProductInformationStepV2,
    createGeneralProductInformationV2Controller,
    createGeneralProductInformationReviewContribution,
    generalProductInformationV2Descriptor,
    generalProductInformationV2StepImplementation,
}
